import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=75a867c4&scoped=true"
import script from "./ChatPanel.vue?vue&type=script&lang=ts"
export * from "./ChatPanel.vue?vue&type=script&lang=ts"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&id=75a867c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a867c4",
  null
  
)

export default component.exports